<!--分期账单明细-->
<template>

  <div>
    <van-nav-bar :title="title" />
    <van-list
        v-model="loading"
        :finished="finished"
        finished-text="哥哥找过了,没有更多了,爱宝爱宝"
        loading-text="宝不着急,哥哥正在找,嗷呜~"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
    >
      <van-swipe-cell v-for="item in list" :key="item.finId">

        <van-cell >
          <!-- 使用 title 插槽来自定义标题 -->
          <template slot="title">
            <van-row type="flex" justify="space-between">
              <van-col span="11" >
                <span style="font-size: 20px">{{splitDate(item.inputDate)}}</span>
                <span> {{splitTime(item.inputDate)}}</span>
              </van-col>
              <van-col span="6">

                <van-tag  plain  :type="getFinType(item.finType)" style="float: right;">{{item.finTypeName}}</van-tag>
              </van-col>
              <van-col span="7">
                <span style="font-size: 20px">￥{{currentAmtMap[item.finId]}}</span>
              </van-col>
            </van-row>
            <van-row type="flex" >
              <van-col span="6">{{item.belongName}}</van-col>
              <van-col span="9"><span style="float:left">{{item.sortName}}</span></van-col>
              <van-col span="9"><span style="color:#969799;font-size: 12px">{{item.sortDetailName}}</span></van-col>
            </van-row>
            <van-row type="flex">
              <van-col span="6" >分期</van-col>
              <van-col span="9" ><span style="float:left">{{"还" + item.returnedCnt + "/共" +item.instalmentsCnt}}期</span></van-col>
              <van-col span="9"><span style="color:#969799;font-size: 12px">还{{checkInteger(item.repayment)}}/余{{(item.amount-checkInteger(item.repayment)).toFixed(2)}}</span></van-col>
            </van-row>

            <van-row type="flex" v-if="item.finType == 12101">
              <van-col span="24" >
                <van-tag  plain round  type="warning" style="margin-top:5px">{{item.payerName}}付款</van-tag>
                <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.usePM">零花钱结算</van-tag>
                <van-tag  plain round  type="warning" style="margin-top:5px" v-if="item.rollOverAccounts">轧账余额{{item.rollOverAccounts}}</van-tag>
              </van-col>
            </van-row>
            <van-row type="flex" justify="space-between">
              <van-col span="24" >
                <span style="float: left;color:#969799;font-size: 12px">{{item.remark}}</span>
              </van-col>
            </van-row>
          </template>

        </van-cell>
      </van-swipe-cell>
    </van-list>

  </div>

</template>

<script>
import * as MyApi from '../../api/URLApiAddr.js'
export default {
  name: 'CreditReportDetailList',
  props:{
    rptId:{
      type: Number
    }
  },
  data() {
    return {
      title: '分期账单详情',
      list: [],
      error: false,
      loading: false,
      finished: false,
      tagType: "danger",
      popupShow: false,
      currentAmtMap: Map
    }
  },
  watch:{
    rptId(){
      this.onLoad();
    }
  },
  methods: {
    onLoad() {
      let params = {
        id: this.rptId
      }
      this.$axios.post(MyApi.QRY_CREDIT_DETAIL,params/*,options*/)
          .then((response) =>  {
            let code = response.code;
            if(code == '200'){

              let data = response.data
              if(data.finList.length >0){
                //ths.list = data.records
                this.list = data.finList
                this.currentAmtMap = data.currentAmtMap
              }
              this.finished = true;
            }
            this.loading = false;
          })
          .catch((err) =>{
            this.loading = false
            this.error = true
            this.$toast.fail("数据初始化异常"+err);
          })

    },
    splitDate(inputDate) {
      return inputDate.substr(0,10)
    },
    splitTime(inputDate) {
      return inputDate.substr(11,5)
    },
    getFinType(finType){
      if(finType == '12101'){
        return "danger"
      }else{
        return  "primary"
      }
      //return finTypeName
    },
    checkInteger(value){
      if(value <= 0){
        return 0;
      }
      return value;
    }
  }
}


</script>

<style scoped="scoped">

.van-list >>> .van-list__finished-text{
  margin-bottom: 50px;
}


</style>
